import React from "react";
import { Animate } from "react-move";

import { easeBounceOut } from "@/utils/animation";

import {
  bucketWidth,
  centerPoint,
  Result,
  spaceBetweenBucketsOffset,
} from "../MeterConstants";

interface Bar {
  startSize: number;
  endSize: number;
}

export default class MeterPreview extends React.Component<any, {}> {
  public render(): JSX.Element {
    const { answer, results } = this.props;

    const sizes: Bar[] = new Array(results.length);

    for (let i = 0; i <= results.length; i++) {
      const startSize = Math.floor(Math.random() * (340 - 20) + 20);
      sizes[i] = { startSize: startSize, endSize: 50 };
    }

    return (
      <g>
        {answer === undefined &&
          results.map((result: Result, index: number) => (
            <Animate
              key={`meter-preview-${index}`}
              start={{
                height: sizes[index].endSize,
                background: "#F0F2F5",
                opacity: 1,
              }}
              enter={{
                height: [sizes[index].startSize, sizes[index].endSize],
                background: "#F0F2F5",
                opacity: [1],
                timing: {
                  duration: 2000,
                  ease: easeBounceOut,
                },
              }}
            >
              {(animation: {
                height: number;
                background: string;
                opacity: number;
              }) => {
                return (
                  <g
                    transform={`translate(${result.bucket -
                      bucketWidth / 2}, ${centerPoint.y - animation.height})`}
                    key={index.toString()}
                  >
                    <rect
                      x={spaceBetweenBucketsOffset / 2}
                      y={0}
                      width={bucketWidth - spaceBetweenBucketsOffset}
                      height={animation.height}
                      fill={animation.background}
                      style={{
                        opacity: animation.opacity,
                      }}
                    />
                  </g>
                );
              }}
            </Animate>
          ))}
      </g>
    );
  }
}
